module.exports = __webpack_public_path__ + "static/media/relay-share-card.4a36873a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/relay-share-card.png
// module id = 2085
// module chunks = 6